export default {
  defaultStyle: data => ({
    color: '#000',
    textAlign: 'left',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
      display: 'table',
      width: '100%',
      backgroundColor: '#fff'
    },
    '&:lang(ar)':{
      textAlign:'right',
      direction:'rtl'
    }
  }),
  portalDesign: data => ({
    background: '#fff',
    //font: "500 16px 'Roboto', sans-serif",
    padding: '0 15px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      boxShadow: 'none',
      padding: '0',
    },
  }),
  smallTable: data => ({
    composes: '$defaultStyle',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      maxWidth: '33.5%'
    }
  }),
  mobileBorderTop: {
    borderTop: '1px solid #D8D8D8',
  },
  list: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display: 'table-cell',
      verticalAlign: 'top',
      width: '33.3333%',
      padding: '13px 20px 30px'
    },
    '& > $listElementPortalDesign:first-child': {
      paddingTop: '20px',
      '@media (min-width: 801px)': {
        paddingTop: '10px',
      },
    },
    '& > $listElementPortalDesign:last-child': {
      paddingBottom: '20px',
      '@media (min-width: 801px)': {
        paddingBottom: '10px',
      },
    }
  }),
  seeHotelList: {
    display: 'block',
    padding: '10px 0 ',
    font:data => '500 16px ' + data.fontFamily1,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    color: data => data.mainColor,
    '&:hover':{
      textDecoration: 'none'
    },
    '& > span': {
      '&:lang(ar)': {
        position: 'relative',
        paddingLeft: '25px'
      }
    }
  },
  seeHotelListIcon: {
    fontSize: '10px',
    border: '1px solid',
    borderRadius: '50%',
    padding: '5px 3px 4px 5px',
    marginLeft: '5px',
    verticalAlign: 'middle',
    '&:lang(ar)':{
      marginRight:'5px',
      marginLeft:'0',
      padding:'5px 5px 4px 3px',
      position:'absolute',
      bottom:'0',
      left:'0'
    }
  },
  dispoTitle: data => ({
    backgroundColor: '#f6f6f6',
    padding: '10px 10px 10px 40px',
    position: 'relative',
    font: '300 13px/1.38 ' + data.fontFamily1,
    border: '1px solid #e1e1e1',
    borderBottom: 0,
    [`@media (min-width: ${data.modalBreak}px)`]: {
      backgroundColor: '#fff',
      border: 'none',
      position: 'relative',
      color: '#000',
      paddingTop: 0,
      minHeight: '18px',
      padding: '10px 0',
      display: 'block',
      borderBottom: '1px solid #d8d8d8',
      font: '500 16px/1.38 ' + data.fontFamily1,
      fontWeight: 500,
      fontSize: '16px',
      '& > span': {
        fontSize: '16px',
        fontWeight: 500,
      }
    },
    '&:lang(ar)':{
      padding:'10px 40px 10px 10px',
      [`@media (min-width: ${data.modalBreak}px)`]:{
        padding:'0 0 10px 0'
      }
    },
  }),
  dispoTitlePortalDesign: data =>({
    padding: '10px 10px 10px 30px',
    position: 'relative',
    font: '300 13px/1.38 ' + data.fontFamily1,
    color: '#000',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      position: 'relative',
      paddingTop: 0,
      minHeight: '18px',
      padding: '10px 0',
      display: 'block',
      font: '500 16px/1.38 ' + data.fontFamily1,
      fontWeight: 500,
      fontSize: '16px',
      borderBottom: '1px solid #d8d8d8',
      '& > span': {
        fontSize: '16px',
        fontWeight: 500,
      }
    },
    '&:lang(ar)':{
      padding:'10px 40px 10px 10px',
      [`@media (min-width: ${data.modalBreak}px)`]:{
        padding:'0 0 10px 0'
      }
    },
  }),
  listElement: data => ({
    border: '1px solid #e1e1e1',
    backgroundColor: '#fff',
    minHeight: '28px',
    padding: '10px',
    display: 'block',
    font: '13px ' + data.fontFamily1,
    color: data.mainColor,
    borderBottom: 0,
    cursor: 'pointer',
    position:'relative',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      border: 'none',
      minHeight: '18px',
      padding: '10px 0',
      borderBottom: '1px solid #d8d8d8'
    },
  }),
  listElementPortalDesign: data => ({
    backgroundColor: '#fff',
    minHeight: '28px',
    padding: '10px 5px',
    display: 'block',
    font: "300 14px 'Roboto', sans-serif",
    color: '#000',
    cursor: 'pointer',
    position:'relative',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      border: 'none',
      minHeight: '18px',
      padding: '10px 5px',
    },
  }),
  cityCountryText: {
    font: "300 12px 'Roboto', sans-serif",
    color: '#767676',
    paddingLeft: '25px',
  },
  boxInfoDestination: {
    display: 'flex',
    flexDirection: 'column',
  },
  boxIconNameDest: {
    display: 'flex',
    alignItems: 'center',
    '& > div > div > svg': {
      position: 'relative',
      top: '3px',
      '@media (min-width: 801px)': {
        top: '1px',
      }
    },
  },
  listAlone: data => ({
    '& $listElement': {
      marginRight: 0,
      '&:lang(ar)':{
        marginRight:'0',
        marginLeft:'0'
      }
    },
    '& $dispoTitle': {
      marginRight: 0,
      '&:lang(ar)':{
        marginRight:'0',
        marginLeft:0
      }
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '13px 20px 20px',
      width: '50%',
      display: 'table-cell'
    }
  }),
  boxBrandHotel: {
    display: 'flex',
    alignItems: 'center',
    '& > div > div > svg': {
      position: 'relative',
      top: '3px',
      '@media (min-width: 801px)': {
        top: '1px',
      }
    },
  },
  boxHotelName: {
    font: "300 14px 'Roboto', sans-serif",
    paddingLeft: '10px',
  },
  clearSearch: data => ({
    position: 'absolute',
    right: 0,
    top: 0,
    width: '30px',
    color: data.mainColor,
    fontSize: '18px',
    lineHeight: '40px',
    textAlign: 'left',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      right: '-6px',
      top: '-6px',
      fontSize: '19px'
    },
    '&:lang(ar)':{
      textAlign:'right',
      right:'auto',
      left:0,
      [`@media (min-width: ${data.modalBreak}px)`]: {
        right:'auto',
        left:'-6px'
      }
    }
  }),
  boxLastSearchs: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
    '& > div > div > svg': {
      '@media (max-width: 800px)': {
        position: 'relative',
        bottom: '4px',
      }
    }
  },
  lastSearchIcon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    fontSize: '21px',
    lineHeight: '1px',
    color: '#21212a',
    '&:lang(ar)':{
      left:'auto',
      right:'12px'
    }
  },
  lastSearchIconPortalDesign: {
    left: '0',
  },
  notFoundSearch: data => ({
    backgroundColor: '#f6f6f6',
    padding: '13px 10px 10px 20px',
    color: '#d0021b',
    font: '300 13px ' + data.fontFamily1,
    [`@media (min-width: ${data.modalBreak}px)`]: {
      backgroundColor: '#fff'
    }
  }),
  publiContainer: data => ({
    display: 'table-cell',
    verticalAlign: 'top',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '13px 20px 30px'
    }
  }),
  publiContent: {
    backgroundColor:'#847648',
    textAlign: 'center',
    padding: '15px',
  },
  publiLogo: {
    maxWidth: '124px',
    fill: '#fff',
    display: 'block',
    margin: '0 auto'
  },
  starPubliTitle:{
    font: data => '600 14px ' + data.fontFamily1,
    display: 'block',
    maxWidth: '200px',
    margin: '10px auto 0',
  },
  starPubliSubTitle:{
    font: data => '14px ' + data.fontFamily1,
    display: 'block',
    marginTop: '10px',
  },
  amenitiesElement: {
    display: 'inline-block',
    marginTop: '8px',
    position: 'relative',
    padding: '11px 0 11px 50px',
    color: '#fff',
    font:data => '16px ' + data.fontFamily1,
    letterSpacing: '.3px',
    '&:lang(ar)':{
      paddingLeft:'11px',
      paddingRight:'50px'
    }
  },
  amenitiesLogo: {
    width: '42px',
    textAlign: 'center',
    background: '#fff',
    color: '#c94',
    position: 'absolute',
    left: '0',
    top: '0',
    WebkitBorderRadius: '50%',
    MozBorderRadius: '50%',
    borderRadius: '50%',
    fontSize: '24px',
    lineHeight: '42px',
    '&:lang(ar)':{
      left:'auto',
      right:0
    }
  },
  listName:{
    display:'inline'
  },
  listNamePortalDesign:{
    display:'inline',
    font: "300 14px 'Roboto', sans-serif",
    color: '#000',
    paddingLeft: '10px'
  },
  numberElements:{
    color:'#9b9b9b'
  },
  numberElementsPortalDesign: {
    font: "300 12px 'Roboto', sans-serif",
    color: '#767676',
    paddingLeft: '25px',
  },
  textElementsPortalDesign: {
    font: "300 12px 'Roboto', sans-serif",
    color:'#767676',
    paddingLeft: '3px',
    textTransform: 'capitalize'
  },
  mapIcon: {
    fontSize: '20px',
    color: '#000'
  },
  toggleButton: data => ({
    position:'relative',
    flex:1,
    padding:'16px 0',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding:'10px 0 11px',
    },
    '& span':{
      position:'absolute',
      right:'10px',
      top:'50%',
      width:'25px',
      marginTop:'-6px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        right:'0',
      },
    }
  }),
  noBordered: data => ({
    border:'none',
    boxSizing:'border-box',
    '&:first-of-type':{
      paddingTop:'0'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      paddingLeft:'10px'
    }
  }),
  hotelListEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0',
    marginBottom: 0
  },
  hotelListEnterActive: {
    maxHeight: '500px',
    transition: 'max-height 500ms ease-out,margin-bottom .3s ease-out',
    overflow: 'hidden',
    marginBottom: '0'
  },
  hotelListLeave: {
    maxHeight: '500px',
    transition: 'max-height 500ms ease-out',
    overflow: 'hidden'
  },
  hotelListLeaveActive: {
    transition: 'max-height 0 ease-out',
    marginBottom: '0',
    maxHeight: '0'
  },
  listContainer:{
    composes:'$listElement',
    display:'flex',
    flexWrap:'wrap',
    padding:'0 10px',
    '&:last-of-type':{
      borderBottom:'none'
    }
  },
  maxList: data => ({
    composes:'$defaultStyle',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display:'flex',
      justifyContent:'space-between',
    },
    '& $publiContainer':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        flex:1
      },
    }
  }),
  flexedList: data => ({
    composes:'$list',
    display:'block',
    width:'auto',
    flex:1,
    background:'#fff',
    maxHeight:'320px',
    overflow:'auto',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      paddingTop:'0',
      paddingBottom:'10px'
    },
    '& $dispoTitle':{
      position:'sticky',
      top:'0',
      zIndex:1,
      background:'#fff',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        paddingTop:'13px',
      },
    }
  }),
  pluggedContainer:{
    width:'100%',
  },
  titleTextContainer: data => ({
    padding:'16px 0',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding:'10px 0 11px',
    },
  }),
  roundedTheme:{
    borderRadius: '25px',
    overflow: 'hidden',
    '& $flexedList':{
      '&:first-of-type':{
        borderRadius: '25px 25px 0 0 ',
      },
      '&:nth-of-type(2)':{
        borderRadius: '0 0 25px 25px',
      },
      '@media (min-width: 801px)': {
        marginRight: '10px',
        '&:first-of-type':{
          borderRadius: '25px 0 0 25px',
        },
        '&:nth-of-type(2)':{
          borderRadius: '0 25px 25px 0',
        },
        '&::-webkit-scrollbar': {
          width: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#ccc',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f5f5f5',
        },
      },
    },
    '@media (max-width: 800px)': {
      '$ &listAlone':{
        '& $dispoTitle':{
          borderRadius: '25px 25px 0 0'
        },
      },
    },
    '& $notFoundSearch':{
      borderRadius: '25px'
    }
  },
};
